var _excluded = ["date", "onDateChange", "focused", "onFocusChange", "id", "numberOfMonths", "displayFormat", "placeholder", "firstDayOfWeek", "label", "hideLabel", "inputSize", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useEffect } from 'react';
import { string, bool, number, func, object, oneOf } from 'prop-types';
import classNames from 'classnames';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { SingleDatePicker } from 'react-dates';
import uuid from 'uuid';
import './DatePicker.scss';
import Label from '../Forms/Label';
var propTypes = {
  onFocusChange: func.isRequired,
  onDateChange: func.isRequired,
  focused: bool.isRequired,
  date: object,

  /** The component will generate an id for you.<br>
   * If you need to create your own, pass it in as a prop. */
  id: string,
  numberOfMonths: number,
  firstDayOfWeek: number,
  displayFormat: string,

  /** Placeholder text when no date is selected */
  placeholder: string,

  /** Label text */
  label: string,

  /** Visually hide the label */
  hideLabel: bool,

  /** Match the size of the input to the rest of your form inputs.
   * The picker itself remains the same size */
  inputSize: oneOf(['small', 'medium', 'large']),

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  numberOfMonths: 1,
  firstDayOfWeek: 1,
  displayFormat: 'DD.MM.YYYY',
  placeholder: 'dd.mm.åååå',
  inputSize: 'medium'
};
/**
 * The Date Picker is a wrapper around the `<SingleDatePicker/>` from `react-dates`, a package created
 * and maintained by [Airbnb](https://github.com/airbnb/react-dates).
 * This wrapper adds some ruter styling and sets some default props. Other than that it works exactly like the original.
 * @description Experimental
 */

var DatePicker = function DatePicker(_ref) {
  var date = _ref.date,
      onDateChange = _ref.onDateChange,
      focused = _ref.focused,
      onFocusChange = _ref.onFocusChange,
      id = _ref.id,
      numberOfMonths = _ref.numberOfMonths,
      displayFormat = _ref.displayFormat,
      placeholder = _ref.placeholder,
      firstDayOfWeek = _ref.firstDayOfWeek,
      label = _ref.label,
      hideLabel = _ref.hideLabel,
      inputSize = _ref.inputSize,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = classNames('rds-datepicker', {
    'rds-datepicker--focused': focused,
    'rds-datepicker--input-size-small': inputSize === 'small',
    'rds-datepicker--input-size-medium': inputSize === 'medium',
    'rds-datepicker--input-size-large': inputSize === 'large'
  }, className); // Use either the prop id or creat a new one

  var _useState = useState(id || "rds-datepicker-".concat(uuid.v4())),
      _useState2 = _slicedToArray(_useState, 1),
      newId = _useState2[0];

  return /*#__PURE__*/React.createElement("div", {
    className: componentClassNames
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: newId,
    labelText: label,
    hideLabel: hideLabel
  }), /*#__PURE__*/React.createElement(SingleDatePicker, _extends({
    date: date,
    onDateChange: onDateChange,
    focused: focused,
    onFocusChange: onFocusChange,
    id: newId,
    numberOfMonths: numberOfMonths,
    displayFormat: displayFormat,
    firstDayOfWeek: firstDayOfWeek,
    placeholder: placeholder
  }, rest)));
};

DatePicker.propTypes = propTypes;
DatePicker.defaultProps = defaultProps;
export default DatePicker;